import type {DynamicFieldData} from '../../../inputs'
import type {CreateMetaSchema} from './getCreateMetaFromFieldValues'
import type {FactoryOptions, XcNwBlockFragment} from '@sdox/api'
import type {ReactNode} from 'react'
import type {FieldValues} from 'react-hook-form'
import type {ZodSchema} from 'zod'
import type {UpdateMetaSchema} from './getUpdateMetaFromFieldValues'

export type CreateBlockFormValues<Data = any> = {
  meta: CreateMetaSchema
  data: Data
}

export type UpdateBlockFormValues<Data = any> = {
  meta: UpdateMetaSchema
  data: Data
}

export type FieldMapper<
  /** Zod Schema infer type */
  FieldValuesData extends FieldValues,
  /** Input */
  MutationInput = any,
> = (data: FieldValuesData) => MutationInput

export type FormConfig<
  /** Zod Schema infer type */
  FieldValuesData extends {meta: CreateMetaSchema | UpdateMetaSchema; data: any} = {meta: any; data: any},
  /** Mutation */
  Mutation = any,
  /** Input */
  MutationInput = any,
  Block extends XcNwBlockFragment = XcNwBlockFragment,
> = {
  validatorSchema: ZodSchema
  inputFields?: DynamicFieldData<FieldValuesData>[]
  customFormNode?: ReactNode
  /** Map the data of the form how the mutation likes it :D */
  fieldMapper?: FieldMapper<FieldValuesData, MutationInput>
  mutationOptions: FactoryOptions<Mutation>
  getDefaultValues?: FieldValuesData['meta'] extends UpdateMetaSchema
    ? (block: Block) => {meta?: any ; data: any}
    : FieldValuesData['meta'] extends CreateMetaSchema
      ? () => {meta?: any; data: any}
      : never
}

type CreateFormConfig = <
  /** Zod Schema infer type */
  FieldValuesData extends {meta: any; data: any},
  /** Mutation */
  Mutation,
  /** Input */
  MutationInput,
  Block extends XcNwBlockFragment = XcNwBlockFragment,
>(
  config: FormConfig<FieldValuesData, Mutation, MutationInput, Block>
) => FormConfig<FieldValuesData, Mutation, MutationInput, Block>

export const createFormConfig: CreateFormConfig = (config) => config
